/* eslint-disable prettier/prettier, react/prop-types */
import { Form, Input } from "antd"
import { useDispatch, useSelector } from "react-redux";
import { Button } from "../../components/buttons/buttons";
import { DataSubmit, DataUpdate } from "../../redux/spares/actionCreator";

export function AddEditSpares({ data, handleClose }) {

    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const { loading } = useSelector(store => store.spares)

    const handleSubmit = (values) => {

        if (data) {
            dispatch(DataUpdate(data.id, values, (isSuccess) => {
                if (isSuccess) {
                    form.resetFields();
                    handleClose();
                }
            }))
        } else {
            dispatch(DataSubmit(values, (isSuccess) => {
                if (isSuccess) {
                    form.resetFields();
                    handleClose();
                }
            }))
        }
    }

    return <Form
        layout="vertical"
        initialValues={data}
        form={form}
        onFinish={handleSubmit}
    >
        <Form.Item label="Name" name="name" rules={[{ required: true }]}>
            <Input className="rounded-6" placeholder="Enter spare name" />
        </Form.Item>

        <Form.Item label="Make" name="make" rules={[{ required: true }]}>
            <Input className="rounded-6" placeholder="Enter spare make" />
        </Form.Item>

        <Form.Item label="Model" name="model" rules={[{ required: true }]}>
            <Input className="rounded-6" placeholder="Enter spare model" />
        </Form.Item>

        <Form.Item label="Serial No" name="serialNo" rules={[{ required: true }]}>
            <Input className="rounded-6" placeholder="Enter serial no" />
        </Form.Item>

        <Form.Item>
            <div className="flex items-center min-md:justify-end justify-center mt-[15px]">
                <Button
                    className="bg-regularBG dark:bg-regularBGdark h-[38px] ltr:mr-[20px] rtl:ml-[20px] px-[22px] text-[15px] text-body dark:text-white60 hover:text-light font-normal border-regular dark:border-white10"
                    onClick={() => {
                        return form.resetFields();
                    }}
                >
                    Reset
                </Button>
                <Button
                    htmlType="submit"
                    type="primary"
                    loading={loading}
                    className="bg-primary hover:bg-primary-hover h-[38px] px-[22px] text-[15px] text-white dark:text-white87 font-normal border-primary"
                >
                    {data ? "Update" : "Create"}
                </Button>
            </div>
        </Form.Item>
    </Form>
}
